<template>
  <section>
    <Fieldset
      :legend="toUpperCase(translate('skills', 'ucfirst'))"
    class="relative w-full px-5 pb-4 mt-5 bg-white rounded-lg shadow-md border border-color-iron"
    >
      <Skeleton v-if="isLoading && skills" height="1.5rem"></Skeleton>
      <ul
        v-else-if="!isLoading && skills.length > 0"
        class="list-inside list-disc"
      > 
        <li v-for="(skill, index) in skills" :key="index" class="mt-3 flex items-center justify-between">
          <div class="flex items-center">
            <span class="font-medium">
              {{ skill.name }}
              <template v-if="skill.proficiency_label || skill.proficiency_level">
                - {{ getProficiencyLevelDisplayName(skill.proficiency_level, skill.proficiency_label) }}
              </template>
            </span>
          </div>
          <i @click="showModal('update','skill',skill)" class="pi pi-pencil cursor-pointer ml-2 text-base"></i>
        </li> 

        <i @click="showModal('create','skill')" class="pi pi-plus cursor-pointer absolute -top-3 right-2 text-lg"></i>
      </ul>
      <ul v-else>
        <li>{{ translate("no skills", "ucfirst") }}</li>
        <i @click="showModal('create','skill')" class="pi pi-plus cursor-pointer absolute top-1 right-5 text-lg"></i>
      </ul>
    </Fieldset>

    <ModalDialogComponent :isvisible="visible" @close-modal="closeModalDialog">
      <template #title>
        {{ displayModalTitle }}
      </template>
      <template #content>
        <ProfessionalSkillForm
          :skill-to-update="skillToUpdate" :curriculum-id="props.skills.curriculum.id" 
          @skills-updated="skillsUpdated"
          @close-modal="closeModalDialog"
        />
      </template>
    </ModalDialogComponent>
  </section>
</template>

<script setup>
import { ref, onMounted, onUpdated } from "vue";
import Fieldset from "primevue/fieldset";
import Skeleton from "primevue/skeleton";
import { translate } from "@/composables/translate";
import requestHandler from "@/composables/requestHandler";
import useModalCurriculum from "@/composables/modalDialogCurriculum";
import ModalDialogComponent from "@/components/Utils/ModalDialogComponent.vue";
import ProfessionalSkillForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalSkillForm.vue";
import useSkillProficiencyLevels from "@/composables/skillProficiencyLevels";
import { toUpperCase } from '@/composables/textUtils';


const props = defineProps({
  skills: {
    type: Array,
    required: true,
    default: ()=> []
  }
});

let skills = ref([]);
let isLoading = ref(false);
let visible = ref(false)  
let skillToUpdate = ref({})  

let { toggleCreateUpdateTitle, displayModalTitle } = useModalCurriculum();

// Usar o composable para níveis de proficiência de habilidades
const { getProficiencyLevelName } = useSkillProficiencyLevels();

// ############ Criação de Métodos/Funções ############

// Função para obter o nome do nível de proficiência
function getProficiencyLevelDisplayName(proficiencyLevel, proficiencyLabel) {
  // Se for um ID numérico, usar o composable
  // Sempre traduzir o label, mesmo que venha do backend
  const proficiencyMap = {
    'beginner': 'Iniciante',
    'advanced beginner': 'Iniciante Avançado',
    'intermediate': 'Intermediário',
    'advanced': 'Avançado',
    'expert': 'Especialista',
    'Iniciante': 'Iniciante',
    'Iniciante Avançado': 'Iniciante Avançado',
    'Intermediário': 'Intermediário',
    'Avançado': 'Avançado',
    'Especialista': 'Especialista'
  };
  // Se vier o label amigável, traduz também
  if (proficiencyLabel && proficiencyLabel !== 'N/A') {
    return proficiencyMap[proficiencyLabel] || proficiencyLabel;
  }
  // Se for um ID numérico, usar o composable
  if (typeof proficiencyLevel === 'number') {
    return getProficiencyLevelName(proficiencyLevel, 'pt');
  }
  // Se for uma string, mapear diretamente
  return proficiencyMap[proficiencyLevel] || proficiencyLevel || 'N/A';
}


function showModal(type, title, skill={}) {
  console.log('🔍 Dados da habilidade:', skill);
  toggleCreateUpdateTitle(type,title)
  skillToUpdate.value = skill
  visible.value = true
}

function closeModalDialog(event){  
  visible.value = event
}

async function skillsUpdated(){  

  isLoading.value = true
  const response = await requestHandler.executeRequest("/api/curriculum",{},"get");
  if (response.success) skills.value = response.data.skills;
  
  isLoading.value = false
}
onUpdated(() => {
  isLoading.value = false
  if (props.skills.skills.length > 0 ) {
    // Mapear dados para garantir que proficiency_level esteja correto
    skills.value = props.skills.skills.map(skill => {
      // Tentar diferentes campos possíveis para proficiency_level
      const proficiencyLevel = skill.proficiency_level || 
                              skill.proficiency_name || 
                              skill.level || 
                              skill.skproficiency_level ||
                              skill.proficiency_id ||
                              skill.proficiency || null;
      return {
        ...skill,
        proficiency_level: proficiencyLevel
      };
    });
  }
})

onMounted(() => {
  isLoading.value = true
});
</script>